export default __webpack_public_path__ + "static/media/manage-content-collapse.2692fe7f.svg";